"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.CustomBorders = void 0;
var _customBorders = require("./customBorders");
exports.PLUGIN_KEY = _customBorders.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _customBorders.PLUGIN_PRIORITY;
exports.CustomBorders = _customBorders.CustomBorders;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/customBorders/index.js
// module id = 1341
// module chunks = 0